import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import prettyBytes from 'pretty-bytes';

const styles = {
    container: {
        cursor: 'pointer',
        textAlign: 'center',
        fontSize: 12,
        padding: '8px 10px',
    },
    icon: {
        fontSize: 20,
    },
    primaryText: {
        marginTop: 3,
    },
};

class LoadImageComponent extends Component {
    static propTypes = {
        className: PropTypes.string,
        hasFailedToLoad: PropTypes.bool,
        imageClickToViewText: PropTypes.string.isRequired,
        imageClickToReloadText: PropTypes.string.isRequired,
        imagePreviewNotAvailableText: PropTypes.string.isRequired,
        mediaSize: PropTypes.number,
        onLoadImage: PropTypes.func.isRequired,
    };

    getSecondaryText() {
        const { hasFailedToLoad, imageClickToReloadText, imageClickToViewText, mediaSize } = this.props;

        if (hasFailedToLoad) {
            return imageClickToReloadText;
        } else if (mediaSize) {
            return imageClickToViewText.replace('{size}', prettyBytes(mediaSize).toUpperCase());
        }

        return imageClickToViewText.replace(/\s?\{size\}\s?/, ' ').trim();
    }

    onClick = (e) => {
        e.stopPropagation();
        this.props.onLoadImage(e);
    };

    render() {
        return (
            <div className={this.props.className} style={styles.container} onClick={this.onClick}>
                <i className="fa fa-camera" style={styles.icon}></i>
                <div style={styles.primaryText}>{this.props.imagePreviewNotAvailableText}</div>
                <div>{this.getSecondaryText()}</div>
            </div>
        );
    }
}

export default connect(
    ({ ui: { text } }) => {
        return {
            imageClickToViewText: text.imageClickToView,
            imageClickToReloadText: text.imageClickToReload,
            imagePreviewNotAvailableText: text.imagePreviewNotAvailable,
        };
    },
    null,
    null,
    { forwardRef: true },
)(LoadImageComponent);
